<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.112.112h19.776v19.776H.112V.112z" />
    <path
      d="M18.602 3.182L17.2 1.49a1.462 1.462 0 00-1.158-.555H3.958c-.475 0-.887.212-1.168.555L1.4 3.182A1.967 1.967 0 00.934 4.46v12.59c0 1.107.907 2.014 2.014 2.014h14.1a2.021 2.021 0 002.015-2.015V4.461c0-.483-.171-.937-.462-1.28h0zM10 15.54L4.461 10h3.524V7.985h4.03V10h3.524l-5.538 5.539-.001.001zM3.07 2.951l.817-1.01h12.085l.947 1.01H3.071z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
